import React from 'react';
import { Link } from 'react-router-dom';

/**
 *
 * @param {string} home 상위 태그의 링크 주소
 * @param {string} title  상위 태그의 컨텐츠 내용
 * @param {string} sublink  하위 경로의 링크 주소
 * @param {string} subTitle  하위 경로의 컨텐츠 내용
 * @returns
 */
const BreadCrumb = (props) => {
  return (
    <div className='pagetitle mb-3 mt-3'>
      <h1>
        <Link className='h1 color-second' to={props.home}>
          {props.title}
        </Link>
      </h1>
    </div>
  );
};

export default React.memo(BreadCrumb);
